// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3zbrG","description":"PatientConsentPreview_description__3hd-R"};